import { forwardRef } from 'react';
import Field from './Field';

// Native date input skinned with tokens: color-scheme follows the tier and accent-color carries Ember into
// the browser's own picker, so keyboard entry and the platform calendar both work. value: 'YYYY-MM-DD'.
const DatePicker = forwardRef(function DatePicker({ label, hint, error, className, ...rest }, ref) {
  return (
    <Field label={label} hint={hint} error={error} className={className}>
      {({ id, describedBy, invalid }) => (
        <input ref={ref} id={id} type="date" className="ui-input" aria-describedby={describedBy} aria-invalid={invalid || undefined} {...rest} />
      )}
    </Field>
  );
});
export default DatePicker;
